// @flow

export const DISABLED = 0;
export const FREE_PROFILE = 10;
export const FULL_PROFILE = 500;
